import React, { Component } from "react";
import { Button } from "@blueprintjs/core";
import { Spinner } from "@blueprintjs/core";
import { TASK_STATUS_COLOR } from "./constants";
import ScaffoldWindow from "./ScaffoldWindow";
//import PMTGSTask from "../new/TaskGroup/PMTGSTask";

class Scaffolds extends Component {


    loading = () => {
        return <div style={{ textAlign: 'center' }}>
            <Spinner />
        </div>;
    }

    render() {
        const p = this.props;

        //console.log(p);

        return (
            <div className="PMTasks">
                <h2 >
                    <span className="subpage_content_header_title">Tasks</span>
                </h2>

                {p.currentPhase !== null ? this.proceedButton() : null}

                {p.isLoading === true ? this.loading() : this.list()}
            </div>
        );
    }

    proceedButton = () => {
        const btnStyle = { // TODOCSS
            'marginTop': '0px',
            'paddingTop': '24px',
            'textAlign': 'center',
            'marginBottom': '24px',
        }
        return <div className="projectmanager_button_row" style={btnStyle}>
            <Button
                large
                icon="build"
                title="Build"
                intent="primary"
                onClick={this.props.build}
            >
                Build
			</Button>
        </div>
    }

    list = () => {
        //console.log('[Scaffolds] list');
        const p = this.props;
        const { storedScaffolds, funcRemoveWindow, funcResize, funcLock, funcHandleChange } = p;

        return storedScaffolds.map((scaff, i) => {

            return <ScaffoldWindow
                color={'black'}
                index={i}
                key={i}
                window={scaff.window}
                data={scaff}
                fieldData={scaff.fields}
                funcResize={funcResize}
                funcLock={funcLock}
                funcRemoveWindow={funcRemoveWindow}
                handleChange={funcHandleChange}
            />
        });
    };

}

export default Scaffolds;



// WEBPACK FOOTER //
// ./src/components/scaffold/Scaffolds.js